import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {borderRadius, calculateRemSize, display, flex, flexDirection, m, p, position, zIndex} from "@pg-design/helpers-css-strings";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {OfferBoxBase} from "../../../../atoms/OfferBoxBase";
import {OfferListNotificationsSubscriptionModal} from "../OfferListNotificationsSubscriptionModal";

const notificationImage = require("../../../images/notification_box_image.jpg");

interface IProps {
    regionName: string;
}

export const NotificationsListBox = (props: IProps) => {
    return (
        <NotificationBox>
            <div css={topSectionWrapper}>
                <Image src={notificationImage} alt={`Zapis na powiadomienia ${props.regionName}`} width="100%" height="100%" css={imageStyle} />
                <Text variant="body_copy_2" css={regionWrapperStyle}>
                    {props.regionName}
                </Text>
            </div>

            <div css={textSection}>
                <Text variant="headline_5" as="p">
                    Chcesz być na bieżąco z ofertami w tej lokalizacji?
                </Text>
                <Text variant="body_copy_2">Zapisz się na powiadomienia i otrzymuj ofetry zgodne z Twoimi preferencjami</Text>
            </div>

            <OfferListNotificationsSubscriptionModal
                customButton={({onClick}) => (
                    <Button variant="filled_primary" type="button" onClick={onClick} css={buttonStyle}>
                        Zapisz się
                    </Button>
                )}
            />
        </NotificationBox>
    );
};

const NotificationBox = styled(OfferBoxBase)`
    height: 100%;
    width: 100%;
    min-height: 42rem;
    justify-content: flex-start;
    overflow: hidden;
`;

const imageStyle = css`
    ${borderRadius(2, 2, 0, 0)};
    width: 100%;
    object-fit: cover;
    height: 20.4rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        height: 24.6rem;
    }
`;

const topSectionWrapper = css`
    ${position("relative")};

    ::after {
        content: "";
        ${display("block")};
        ${position("absolute")};
        top: 0;
        left: 50%;
        height: 100%;
        width: 60%;
        background: radial-gradient(circle closest-side, ${getThemeVariable("colors.primary")}, rgb(255, 255, 255, 0));
        border-radius: 50%;
        transform: translate(-50%, 0);
        opacity: 0.4;
    }
`;

const regionWrapperStyle = css`
    ${position("absolute")};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    ${p(1, 2)};
    ${borderRadius(2)};
    ${zIndex(1)};
`;

const textSection = css`
    ${p(2)};
    ${flex()};
    ${flexDirection("column")};
    gap: ${calculateRemSize(2)};
    flex-grow: 1;

    @media (max-width: ${getThemeBreakpoint().md}) {
        min-height: 180px;
    }
`;

const buttonStyle = css`
    ${m(0, 2, 2, 2)};
`;
